import { getPortalConfig, listenForConfigChange } from "@sinch/shell-config";
import { useEffect, useState } from "react";

const queryMetaTag = (name: string) =>
  document.head.querySelector<HTMLMetaElement>(`meta[name=${name}]`);

export const setPortalConfig = (name: string, value: string) => {
  const metaTags = document.querySelectorAll("head > meta");

  const existingElement = queryMetaTag(name);

  if (existingElement) {
    existingElement.content = value;
    return;
  }

  const newMeta = document.createElement("meta");
  newMeta.name = name;
  newMeta.content = value;

  const lastMetaTag = metaTags[metaTags.length - 1];
  if (lastMetaTag) {
    lastMetaTag.insertAdjacentElement("afterend", newMeta);
  } else {
    document.head.appendChild(newMeta);
  }

  return () => {
    document.head.removeChild(newMeta);
  };
};

// Ideally, only the shell can set the config values. @sinch/shell-config is therefore, read-only
export { getPortalConfig, listenForConfigChange };

// TODO: move this to @sinch/shell-config or @sinch/mfe-helper-react ?
export const usePortalConfig = (name: string) => {
  const [value, setValue] = useState<string | null>(null);

  useEffect(() => {
    const initialValue = getPortalConfig(name);
    setValue(initialValue ?? null);

    const unsubscribe = listenForConfigChange(name, (newValue) => {
      setValue(newValue);
    });

    return () => {
      unsubscribe();
    };
  }, [name]);

  return value;
};
